import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { NoResults } from "lib/@components/no-results/no-results"
import { useEffect, useMemo } from "react"
import { ResetTabledRepeat } from "event-definitions"
import { ExportScheduleRow } from "./export-schedule-row"

export function SchedulesTable() {
    const { target } = useBoundContext()
    const schedules = useMemo(getSchedules, [target])
    const tableHeaders = [
        { title: "Id", fieldKey: "id", sortable: true },
        { title: "Title", fieldKey: "title", sortable: true },
        { title: "Code", fieldKey: "code", sortable: true },
        { title: "Version", fieldKey: "version", sortable: true },
        { title: "Download" },
    ]

    useEffect(resetTable, [target])

    if (!schedules.length) {
        return <NoResults />
    }

    return (
        <TabledRepeat
            items={schedules}
            itemPass="schedule"
            itemComponent={<ExportScheduleRow />}
            tableHeaders={tableHeaders}
            paged
        />
    )

    function getSchedules() {
        return (
            target?.edges
                ?.map((scheduleEdge) => {
                    const { approved, id } = scheduleEdge?.node ?? {}

                    if (!approved) {
                        return null
                    }

                    return {
                        ...approved,
                        id,
                    }
                })
                .filter(Boolean) ?? []
        )
    }

    function resetTable() {
        ResetTabledRepeat.raiseOnce()
    }
}
